import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { createCustomerBooking } from "@/services/customer-booking/customer-booking.service";
import type {
  CustomerBookingRequest,
  CustomerBookingResponse,
} from "@/types/customer-booking";

interface BookingState {
  loading: boolean;
  error: string | null;
  bookingData: CustomerBookingResponse | null;
}

const initialState: BookingState = {
  loading: false,
  error: null,
  bookingData: null,
};

export const submitBooking = createAsyncThunk(
  "booking/submit",
  async (
    payload: CustomerBookingRequest & { keycloakToken?: string },
    { rejectWithValue },
  ) => {
    // Extract the keycloak token from payload if present
    const { keycloakToken, ...bookingData } = payload as any;

    console.log("📝 Redux Thunk - Booking Submission");
    console.log(
      `🔐 Token available: ${keycloakToken ? "✅ Yes" : "❌ No (Missing token!)"}`,
    );

    const result = await createCustomerBooking(
      bookingData as CustomerBookingRequest,
      keycloakToken,
    );
    if (result.success && result.data) {
      return result.data;
    }
    return rejectWithValue(result.error || "Booking failed");
  },
);

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetBooking: (state) => {
      state.loading = false;
      state.error = null;
      state.bookingData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        submitBooking.fulfilled,
        (state, action: PayloadAction<CustomerBookingResponse>) => {
          state.loading = false;
          state.bookingData = action.payload;
        },
      )
      .addCase(submitBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetBooking } = bookingSlice.actions;
export default bookingSlice.reducer;
